import * as React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import AppointmentForm from '../../organisms/Forms/AppointmentForm';

const HcdRDVMobile = () => {
  const card = useSelector(state => get(state, 'cards.item'));

  if (!card) return <div />;

  return (
    <div
      id="rdv"
      className="page profile-content__rdv profile-content__rdv--mobile"
    >
      <AppointmentForm card={card} />
    </div>
  );
};

export default HcdRDVMobile;
